module.exports = __webpack_public_path__ + "static/media/bolt-download1.f0bf2971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bolt-download1.png
// module id = 347
// module chunks = 0